
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trends",
      function () {
        return require("private-next-pages/trends.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trends"])
      });
    }
  